import useragent from '@finance/useragent'
import toast from '@common/toast'
import { domain } from '@finance/domain'

import share from './share'

export const SHARE_TITLE = '点我瓜分亿元红包+免单大奖，快来领取！'
export const SHARE_CONTENT = '来随手记双12，最高可得88元现金，赢1212元免单大奖。'
export const SHARE_URL = `https://t.feidee.com/financeWeb?url=${encodeURIComponent(window.location.href)}`
export const SELF_URL = `${domain.res}/act/pdt-2020-freeorder-1212/index.html`

const TOAST_MSG = (() => {
  if (useragent.isSuishouji || useragent.isKaniu || useragent.isWechat) {
    return '分享成功'
  }
  return '邀请链接已复制，直接去粘贴分享给您的好友吧~'
})()

const shareHandle = () => {
  share(SHARE_TITLE, SHARE_CONTENT, SELF_URL)
    .then(() => {
      !(useragent.isSuishouji || useragent.isKaniu) && toast(TOAST_MSG)
    })
}

export default shareHandle
